import {CardSection} from "./common/Card";
import {useState} from "react";
import {Alert} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import {DateRangePicker} from "./common/DateRangePicker";

import {LondonDateRange} from "../ISODateRange";
import {DownloadButton} from "./common/SubmitButton";
import {Result} from "../client/Result";
import {BuildingInput} from "./BuildingInput";
import {Building} from "./BuildingStatus";
import {DateRange} from "../client/DataClient";


interface EventStatsExportProps {
    download: (range: DateRange, building: Building) => Promise<Result<void>>
    buildings: Building[],
    className?: string
}

export const EventStatsExport = ({ download, buildings, className }: EventStatsExportProps) => {

    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [dateRangeValid, setDateRangeValid] = useState(false)
    const [building, setBuilding] = useState<Building>()

    const [validated, setValidated] = useState(false);

    const [errorMessage, setErrorMessage] = useState<string>()

    async function handleSubmit(event) {
        const form = event.currentTarget
        setErrorMessage(undefined)
        event.preventDefault()
        setValidated(true)
        if (form.checkValidity() === true && dateRangeValid && building) {
            const dateRange = new LondonDateRange(startDate, endDate)
            const submissionResult = await download(dateRange.range, building)
            submissionResult.fold(
                () => undefined,
                err => setErrorMessage(`An error occurred - #ask-tech for support. ${err}`)
            )
        } else {
            form.reportValidity()
        }
    }

    return <CardSection className={className} header={'Event Stats Export'} as="h6">
        <Form noValidate validated={validated} >
            <BuildingInput testId={"EventStatsReportBuildingInput"} className={'mb-3'} buildings={buildings} onBuildingChange={b => {
                setErrorMessage(undefined)
                setBuilding(b)
            }} />
            <DateRangePicker testId={'_eventStatsReport'} start={startDate} end={endDate} onEndChange={setEndDate} onStartChange={setStartDate} setErrorMessage={setErrorMessage} reportIsValid={setDateRangeValid} />
            <DownloadButton text='Download CSVs (zipped)' dataTestId='EventStatsReportDownloadButton'
                disabled={!(startDate && endDate && (startDate <= endDate))}
                onSubmit={handleSubmit}/>
            {errorMessage &&
                <Alert data-testid='errorMessage' variant='danger'>{errorMessage}</Alert>}
        </Form>
    </CardSection>
}
